export const registerEmailVerificationInitialState = {
  isVerified: false,
  isVerifyingEmail: false
}

export type RegisterEmailVerificationState = typeof registerEmailVerificationInitialState
